import * as headerBlock from '../header/';
import debounce from 'v-debounce';

const spinner = require('vue-strap').spinner;

export default {
  name: 'users-permissions',
  props: [
    'onLogout',
    'access_token',
    'authUser',
  ],
  components: { headerBlock, spinner },
  mounted() {

  },
  data() {
    return {
      usersList: [],
      tabIndex: 0,
      breadCrumbItems: [
        {
          text: 'Home',
          to: `${process.env.START_URL}/`,
        }, {
          text: 'Users & Permissions',
          active: true,
        },
      ],


      fieldsAdmin: {
        index: {
          label: '#',
        },
        first_name: {
          label: 'First Name',
        },
        last_name: {
          label: 'Last Name',
        },
        role_display: {
          label: 'Role',
        },
        areas: {
          label: 'Access area',
        },
        upn: {
          label: 'UPN',
        },
      },
      fieldsBasic: {
        index: {
          label: '#',
        },
        first_name: {
          label: 'First Name',
        },
        last_name: {
          label: 'Last Name',
        },
        areas: {
          label: 'Access area',
        },
        upn: {
          label: 'UPN',
        },
      },
      currentPage: 1,
      perPage: 5,
      filter: null,
      areas: [],
      processLoading: false,
    };
  },
  methods: {
    onAddAdminClick() {
      console.log('onAddAdminClick');
      this.navigateTo("AddAdmin", null);
    },
    onAddUserClick() {
      console.log('onAddUserClick');
      this.navigateTo("AddUser", null);
    },
    onAdminRowClick(item, index) {
      console.log('onRowClick', item, index);
      this.navigateTo("AddAdmin", item.id);
      /*this.$router.push({
        name: 'Change Admin',
        params: { userId: item.id },
      });*/
    },
    onBasicRowClick(item, index) {
      console.log('onRowClick', item, index);
      this.navigateTo("AddUser", item.id);
      /*this.$router.push({
        name: 'Change User',
        params: { userId: item.id },
      });*/
    },
    navigateTo(pageName, userId) {      
      var newUrl = window.location.href;
      
      var replacement = "/" + pageName;
      if(userId) {
        replacement += "/" + userId;
      }

      newUrl = newUrl.replace('/usersPermissions', replacement);
      newUrl = newUrl.replace('/UsersPermissions', replacement);
      
      var win = window.open(newUrl, '_blank');
      win.focus();
    },
    // onLogout() {
    //   this.access_token = '';
    //   this.authUser = null;
    // },
    getUsersList() {
      let url = 'users/';
      if (this.$route.params.companyId) {
        url = `${url}?company=${this.$route.params.companyId}`;
      }
      return this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            // that.$set(that, 'moduleError', true);
            return null;
          }
          this.usersList = response.body.filter((user) => !user.is_deleted);
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    createAreasTree(areas, parrent = null) {
      for (let i = 0; i < areas.length; i++) {
        areas[i].parrent = parrent;
        this.createAreasTree(areas[i].subareas, areas[i]);
      }
    },
    getAreaById(id, area = this.areas) {
      for (let i = 0; i < area.length; i++) {
        if (area[i].id === id) {
          return area[i];
        }
        const res = this.getAreaById(id, area[i].subareas);
        if (res) {
          return res;
        }
      }
      return null;
    },

    getUserArea(areas) {
      const result = [];
      // for (let i = 0; i < areas.length; i++) {
      //   const res = this.getUserArea(areas[i].subareas);
      //   for (let j = 0; j < res.length; j++) {
      //     result.push(areas[i].name + '/' + res[j]);
      //   }
      //   if (res.length === 0) {
      //     result.push(areas[i].name);
      //   }
      // }
      for (let i = 0; i < areas.length; i++) {
        if (areas[i].is_system || !areas[i].is_active) {
          continue;
        }
        let area = this.getAreaById(areas[i].id);
        let areaPath = '';
        if (!area) continue;
        do {
          areaPath = area.name.concat((areaPath) ? '/'.concat(areaPath) : '');
          area = area.parrent;
        }
        while (area);
        result.push(areaPath);
      }
      return result;
    },
    getWorkingAreas() {
      let url = 'areas/?is_system=false';
      if (this.$route.params.companyId) {
        url = `${url}&company=${this.$route.params.companyId}`;
      }
      return this.$http.get(url,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            return null;
          }
          this.areas = response.body;
          this.createAreasTree(this.areas);
          return response;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
  },
  computed: {

  },
  created() {
    this.processLoading = true;
    this.getWorkingAreas()
    .then(() => this.getUsersList())
    .then(() => {
      this.processLoading = false;
    })
    .catch(() => {
      this.processLoading = false;
    });
    if (this.$route.params.type === 'user') {
      this.tabIndex = 1;
    }
  },
  directives: {
    debounce
  }
};



// WEBPACK FOOTER //
// ./src/components/usersPermissions/usersPermissions.component.js